<div class="map-container">
  <div [id]="mapId" class="google-map"></div>
  <img src="/assets/icon/location_pin.svg" class="center-pin" alt="center pin" />
  <div class="autocomplete-container">
    <app-google-autocomplete (addressSelected)="onAddressChange($event)" />
  </div>
</div>
<footer>
  <div>
    <label>Coordinates:</label>
    <span class="ms-2 fw-bolder">{{ center().lat }}, {{ center().lng }}</span>
  </div>
  <button appReadOnly mat-flat-button color="accent" (click)="_dialogRef.close(center())">Confirm Location</button>
</footer>
